<div
  class="container {{ `align-${align()}` }}"
  [class.center]="isCentered()"
  [style.gap.px]="gap()"
>
  <div
    class="box {{ color() }} {{ `align-${align()}` }}"
    [class.background]="hasColoredBackground()"
    [class.transparent]="hasTransparentBackground()"
    [class.shadow]="hasShadow()"
    [style.minWidth.px]="size()"
    [style.width.px]="size()"
    [style.height.px]="size()"
  >
    <ng-content select="onyx-icon"></ng-content>
    <ng-content select="[icon]"></ng-content>
  </div>

  <div class="wrapper">
    <div class="content">
      @if (label(); as label) {
        <p class="f-muted">{{ label | translate }}</p>
      }

      <ng-content></ng-content>
    </div>
  </div>
</div>
